import { render, staticRenderFns } from "./detailPreview.vue?vue&type=template&id=7395b5b4&scoped=true"
import script from "./detailPreview.vue?vue&type=script&lang=js"
export * from "./detailPreview.vue?vue&type=script&lang=js"
import style0 from "./detailPreview.vue?vue&type=style&index=0&id=7395b5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7395b5b4",
  null
  
)

export default component.exports